// ─── Linear 2-level (Categories → Items) ──────────

export const CATEGORY_OPTIONS = [
  { value: "fruits", display: "Fruits", icon: "FolderSimple", hasChildren: true },
  { value: "vegetables", display: "Vegetables", icon: "FolderSimple", hasChildren: true },
  { value: "grains", display: "Grains", icon: "FolderSimple", hasChildren: true },
];

export const ITEMS_MAP = {
  fruits: [
    { value: "apple", display: "Apple", icon: "Tag" },
    { value: "banana", display: "Banana", icon: "Tag" },
    { value: "cherry", display: "Cherry", icon: "Tag" },
    { value: "mango", display: "Mango", icon: "Tag" },
    { value: "orange", display: "Orange", icon: "Tag" },
  ],
  vegetables: [
    { value: "carrot", display: "Carrot", icon: "Tag" },
    { value: "broccoli", display: "Broccoli", icon: "Tag" },
    { value: "spinach", display: "Spinach", icon: "Tag" },
    { value: "tomato", display: "Tomato", icon: "Tag" },
  ],
  grains: [
    { value: "rice", display: "Rice", icon: "Tag" },
    { value: "wheat", display: "Wheat", icon: "Tag" },
    { value: "oats", display: "Oats", icon: "Tag" },
  ],
};

// ─── Branching (Settings with different sub-menus) ─

export const SETTINGS_META = [
  { value: "appearance", display: "Appearance", icon: "Palette", hasChildren: true },
  { value: "notifications", display: "Notifications", icon: "Bell", hasChildren: true },
  { value: "privacy", display: "Privacy", icon: "Lock", hasChildren: true },
];

const CHILD_OPTIONS = {
  appearance: [
    { value: "dark_mode", display: "Dark Mode", icon: "Moon" },
    { value: "light_mode", display: "Light Mode", icon: "Sun" },
    { value: "system_theme", display: "System Default", icon: "Desktop" },
    { value: "high_contrast", display: "High Contrast", icon: "Eye" },
  ],
  notifications: [
    { value: "email", display: "Email Notifications", icon: "Envelope" },
    { value: "push", display: "Push Notifications", icon: "DeviceMobile" },
    { value: "sms", display: "SMS Alerts", icon: "ChatText" },
    { value: "none", display: "Disable All", icon: "BellSlash" },
  ],
  privacy: [
    { value: "public", display: "Public Profile", icon: "Globe" },
    { value: "private", display: "Private Profile", icon: "LockSimple" },
    { value: "friends_only", display: "Friends Only", icon: "Users" },
  ],
};

export const getSettingsChildOptions = (metaValue) => CHILD_OPTIONS[metaValue] || [];

// ─── 3-level deep (Regions → Countries → Cities) ──

export const REGION_OPTIONS = [
  { value: "asia", display: "Asia", icon: "FolderSimple", hasChildren: true },
  { value: "europe", display: "Europe", icon: "FolderSimple", hasChildren: true },
  { value: "americas", display: "Americas", icon: "FolderSimple", hasChildren: true },
];

export const COUNTRY_OPTIONS = {
  asia: [
    { value: "india", display: "India", icon: "FolderSimple", hasChildren: true },
    { value: "japan", display: "Japan", icon: "FolderSimple", hasChildren: true },
    { value: "thailand", display: "Thailand", icon: "FolderSimple", hasChildren: true },
  ],
  europe: [
    { value: "france", display: "France", icon: "FolderSimple", hasChildren: true },
    { value: "germany", display: "Germany", icon: "FolderSimple", hasChildren: true },
    { value: "italy", display: "Italy", icon: "FolderSimple", hasChildren: true },
  ],
  americas: [
    { value: "usa", display: "USA", icon: "FolderSimple", hasChildren: true },
    { value: "brazil", display: "Brazil", icon: "FolderSimple", hasChildren: true },
    { value: "canada", display: "Canada", icon: "FolderSimple", hasChildren: true },
  ],
};

export const CITY_OPTIONS = {
  india: [
    { value: "mumbai", display: "Mumbai", icon: "MapPin" },
    { value: "delhi", display: "Delhi", icon: "MapPin" },
    { value: "bangalore", display: "Bangalore", icon: "MapPin" },
  ],
  japan: [
    { value: "tokyo", display: "Tokyo", icon: "MapPin" },
    { value: "osaka", display: "Osaka", icon: "MapPin" },
    { value: "kyoto", display: "Kyoto", icon: "MapPin" },
  ],
  thailand: [
    { value: "bangkok", display: "Bangkok", icon: "MapPin" },
    { value: "chiang_mai", display: "Chiang Mai", icon: "MapPin" },
  ],
  france: [
    { value: "paris", display: "Paris", icon: "MapPin" },
    { value: "lyon", display: "Lyon", icon: "MapPin" },
    { value: "marseille", display: "Marseille", icon: "MapPin" },
  ],
  germany: [
    { value: "berlin", display: "Berlin", icon: "MapPin" },
    { value: "munich", display: "Munich", icon: "MapPin" },
  ],
  italy: [
    { value: "rome", display: "Rome", icon: "MapPin" },
    { value: "milan", display: "Milan", icon: "MapPin" },
    { value: "florence", display: "Florence", icon: "MapPin" },
  ],
  usa: [
    { value: "new_york", display: "New York", icon: "MapPin" },
    { value: "san_francisco", display: "San Francisco", icon: "MapPin" },
    { value: "chicago", display: "Chicago", icon: "MapPin" },
  ],
  brazil: [
    { value: "sao_paulo", display: "Sao Paulo", icon: "MapPin" },
    { value: "rio", display: "Rio de Janeiro", icon: "MapPin" },
  ],
  canada: [
    { value: "toronto", display: "Toronto", icon: "MapPin" },
    { value: "vancouver", display: "Vancouver", icon: "MapPin" },
    { value: "montreal", display: "Montreal", icon: "MapPin" },
  ],
};

// ─── Lazy-load / Annotation hierarchy simulation ───

export const THEME_META_OPTIONS = [
  { value: "themes", display: "Themes", icon: "FolderSimple", hasChildren: true },
  { value: "subThemes", display: "Sub-Themes", icon: "FolderSimple", hasChildren: true },
  { value: "tags", display: "Tags", icon: "Tag", hasChildren: true },
];

export const LAZY_THEMES = [
  { value: "climate", display: "Climate Change", icon: "FolderSimple", hasChildren: true },
  { value: "health", display: "Public Health", icon: "FolderSimple", hasChildren: true },
  { value: "education", display: "Education", icon: "FolderSimple", hasChildren: true },
];

export const LAZY_SUBTHEMES = {
  climate: [
    { value: "emissions", display: "Carbon Emissions", icon: "FolderSimple", hasChildren: true },
    { value: "renewable", display: "Renewable Energy", icon: "FolderSimple", hasChildren: true },
    { value: "adaptation", display: "Climate Adaptation", icon: "FolderSimple", hasChildren: true },
  ],
  health: [
    { value: "vaccines", display: "Vaccines", icon: "FolderSimple", hasChildren: true },
    { value: "mental", display: "Mental Health", icon: "FolderSimple", hasChildren: true },
  ],
  education: [
    { value: "stem", display: "STEM Education", icon: "FolderSimple", hasChildren: true },
    { value: "literacy", display: "Literacy Programs", icon: "FolderSimple", hasChildren: true },
  ],
};

export const LAZY_TAGS = {
  emissions: [
    { value: "co2", display: "CO2 Levels", icon: "Tag" },
    { value: "methane", display: "Methane", icon: "Tag" },
    { value: "deforestation", display: "Deforestation", icon: "Tag" },
  ],
  renewable: [
    { value: "solar", display: "Solar Power", icon: "Tag" },
    { value: "wind", display: "Wind Energy", icon: "Tag" },
  ],
  adaptation: [
    { value: "flooding", display: "Flood Barriers", icon: "Tag" },
    { value: "drought", display: "Drought Resistance", icon: "Tag" },
  ],
  vaccines: [
    { value: "mrna", display: "mRNA Vaccines", icon: "Tag" },
    { value: "distribution", display: "Distribution", icon: "Tag" },
  ],
  mental: [
    { value: "therapy", display: "Therapy Access", icon: "Tag" },
    { value: "awareness", display: "Awareness Campaigns", icon: "Tag" },
  ],
  stem: [
    { value: "coding", display: "Coding Programs", icon: "Tag" },
    { value: "robotics", display: "Robotics", icon: "Tag" },
  ],
  literacy: [
    { value: "reading", display: "Reading Programs", icon: "Tag" },
    { value: "libraries", display: "Mobile Libraries", icon: "Tag" },
  ],
};

// ─── Pre-loaded nested tree (Regions → Countries → Cities) ──

export const NESTED_TREE_OPTIONS = [
  {
    value: "asia", display: "Asia", icon: "FolderSimple", children: [
      { value: "india", display: "India", icon: "FolderSimple", children: [
        { value: "mumbai", display: "Mumbai", icon: "MapPin" },
        { value: "delhi", display: "Delhi", icon: "MapPin" },
        { value: "bangalore", display: "Bangalore", icon: "MapPin" },
      ]},
      { value: "japan", display: "Japan", icon: "FolderSimple", children: [
        { value: "tokyo", display: "Tokyo", icon: "MapPin" },
        { value: "osaka", display: "Osaka", icon: "MapPin" },
        { value: "kyoto", display: "Kyoto", icon: "MapPin" },
      ]},
      { value: "thailand", display: "Thailand", icon: "FolderSimple", children: [
        { value: "bangkok", display: "Bangkok", icon: "MapPin" },
        { value: "chiang_mai", display: "Chiang Mai", icon: "MapPin" },
      ]},
    ],
  },
  {
    value: "europe", display: "Europe", icon: "FolderSimple", children: [
      { value: "france", display: "France", icon: "FolderSimple", children: [
        { value: "paris", display: "Paris", icon: "MapPin" },
        { value: "lyon", display: "Lyon", icon: "MapPin" },
        { value: "marseille", display: "Marseille", icon: "MapPin" },
      ]},
      { value: "germany", display: "Germany", icon: "FolderSimple", children: [
        { value: "berlin", display: "Berlin", icon: "MapPin" },
        { value: "munich", display: "Munich", icon: "MapPin" },
      ]},
      { value: "italy", display: "Italy", icon: "FolderSimple", children: [
        { value: "rome", display: "Rome", icon: "MapPin" },
        { value: "milan", display: "Milan", icon: "MapPin" },
        { value: "florence", display: "Florence", icon: "MapPin" },
      ]},
    ],
  },
  {
    value: "americas", display: "Americas", icon: "FolderSimple", children: [
      { value: "usa", display: "USA", icon: "FolderSimple", children: [
        { value: "new_york", display: "New York", icon: "MapPin" },
        { value: "san_francisco", display: "San Francisco", icon: "MapPin" },
        { value: "chicago", display: "Chicago", icon: "MapPin" },
      ]},
      { value: "brazil", display: "Brazil", icon: "FolderSimple", children: [
        { value: "sao_paulo", display: "Sao Paulo", icon: "MapPin" },
        { value: "rio", display: "Rio de Janeiro", icon: "MapPin" },
      ]},
      { value: "canada", display: "Canada", icon: "FolderSimple", children: [
        { value: "toronto", display: "Toronto", icon: "MapPin" },
        { value: "vancouver", display: "Vancouver", icon: "MapPin" },
        { value: "montreal", display: "Montreal", icon: "MapPin" },
      ]},
    ],
  },
];

// ─── Dataset presets ────────────────────────────────

export const DATASET_OPTIONS = [
  { value: "tree", display: "Tree (Pre-loaded nested data)" },
  { value: "linear", display: "Linear (Categories → Items)" },
  { value: "branching", display: "Branching (Settings Menu)" },
  { value: "deep", display: "3-Level (Regions → Countries → Cities)" },
  { value: "lazy", display: "Lazy Load (Themes → SubThemes → Tags)" },
];

export const FOLDER_MODE_OPTIONS = [
  { value: "exclusive", display: "Exclusive" },
  { value: "inclusive", display: "Inclusive" },
];
